import { Input } from "@cofano/cck";
import { NumericFormat } from "react-number-format";
import { ReactNode } from "react";
import { getDecimalSeparator, getThousandSeparator, getStoredRegionLocale } from "utils/regionUtils";

const NumberInput = ({
	value,
	onChange,
	addonAfter,
	addonBefore,
	decimalScale,
	disabled,
	readOnly,
	thousandSeparator,
	autoFocus,
}: {
	value: number | null | undefined;
	onChange: (v: number | null) => void;
	addonAfter?: ReactNode;
	addonBefore?: ReactNode;
	decimalScale?: number;
	disabled?: boolean;
	readOnly?: boolean;
	thousandSeparator?: boolean;
	autoFocus?: boolean;
}) => {
	const regionLocale = getStoredRegionLocale();

	return (
		<NumericFormat
			autoFocus={autoFocus}
			disabled={disabled}
			readOnly={readOnly}
			value={value}
			customInput={Input}
			onValueChange={(values) => onChange(values.floatValue ?? null)}
			decimalScale={decimalScale}
			decimalSeparator={getDecimalSeparator(regionLocale)}
			thousandSeparator={thousandSeparator ?? getThousandSeparator(regionLocale)}
			addonAfter={addonAfter}
			addonBefore={addonBefore}
		/>
	);
};

export default NumberInput;
